import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "circle",
		children: /* @__PURE__ */ _jsx("path", {
			id: "icon",
			d: "M8 14.6667C7.07777 14.6667 6.21111 14.4917 5.39999 14.1417C4.58888 13.7917 3.88333 13.3167 3.28333 12.7167C2.68333 12.1167 2.20833 11.4111 1.85833 10.6C1.50833 9.78889 1.33333 8.92222 1.33333 8C1.33333 7.07778 1.50833 6.21111 1.85833 5.4C2.20833 4.58889 2.68333 3.88333 3.28333 3.28333C3.88333 2.68333 4.58888 2.20833 5.39999 1.85833C6.21111 1.50833 7.07777 1.33333 8 1.33333C8.92222 1.33333 9.78888 1.50833 10.6 1.85833C11.4111 2.20833 12.1167 2.68333 12.7167 3.28333C13.3167 3.88333 13.7917 4.58889 14.1417 5.4C14.4917 6.21111 14.6667 7.07778 14.6667 8C14.6667 8.92222 14.4917 9.78889 14.1417 10.6C13.7917 11.4111 13.3167 12.1167 12.7167 12.7167C12.1167 13.3167 11.4111 13.7917 10.6 14.1417C9.78888 14.4917 8.92222 14.6667 8 14.6667ZM8 13.3333C9.48888 13.3333 10.75 12.8167 11.7833 11.7833C12.8167 10.75 13.3333 9.48889 13.3333 8C13.3333 6.51111 12.8167 5.25 11.7833 4.21667C10.75 3.18333 9.48888 2.66667 8 2.66667C6.51111 2.66667 5.25 3.18333 4.21666 4.21667C3.18333 5.25 2.66666 6.51111 2.66666 8C2.66666 9.48889 3.18333 10.75 4.21666 11.7833C5.25 12.8167 6.51111 13.3333 8 13.3333Z",
			fill: "currentColor"
		})
	})
});
export default SvgCircle;
